import { clientLogos } from '@/mocks/clientLogos';

export default function ClientLogos() {
  const allLogos = [...clientLogos, ...clientLogos];

  return (
    <section className="py-14 md:py-20 bg-background-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8 md:mb-10">
        <div className="text-center">
          <p className="text-primary-500 font-bold text-sm tracking-widest uppercase mb-2">
            BIFF'i SEÇTİLER
          </p>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-50 tracking-tighter">
            SAFIMIZDAKİLER
          </h2>
          <p className="text-sm md:text-base text-foreground-400 mt-3 max-w-xl mx-auto font-medium">
            Aralarına katılmak ister misin? Biff ile farkı hisset.
          </p>
        </div>
      </div>

      {/* Marquee */}
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-background-100 to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-background-100 to-transparent z-10 pointer-events-none" />

        <div className="flex animate-marquee">
          {allLogos.map((logo, idx) => (
            <div
              key={`${logo.id}-${idx}`}
              className="flex-shrink-0 mx-6 md:mx-10 flex items-center justify-center"
            >
              <img
                src={logo.src}
                alt={logo.name}
                width="160"
                height="64"
                className="h-16 md:h-20 w-auto opacity-50 hover:opacity-90 transition-opacity duration-300 grayscale hover:grayscale-0"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}